import { useState } from 'react'
import PrimaryButton from '../../global/components/buttons/primary-button/PrimaryButton'
import styles from './styles.module.css'
import { fetchData } from '../../global/utils/fetch'
import { triggerDaySettingsMaintenance } from '../api'

interface MaintenanceResponse {
  success: boolean
  techniciansProcessed: number
  techniciansUpdated: number
  daySettingsCreated: number
  errors: string[]
  executionTimeMs: number
}

export default function DaySettingsMaintenance() {
  const [loading, setLoading] = useState(false)

  async function onTriggerClick() {
    setLoading(true)
    try {
      const response = (await fetchData(
        triggerDaySettingsMaintenance(),
      )) as MaintenanceResponse

      if (response.success) {
        alert(
          `✅ Maintenance completed successfully!\n\n` +
          `Technicians Processed: ${response.techniciansProcessed}\n` +
          `Technicians Updated: ${response.techniciansUpdated}\n` +
          `Day Settings Created: ${response.daySettingsCreated}\n` +
          `Execution Time: ${response.executionTimeMs}ms\n` +
          `${response.errors.length > 0 ? `\nErrors: ${response.errors.join(', ')}` : ''}`
        )
      } else {
        alert(`❌ Maintenance failed!\n\nErrors: ${response.errors.join(', ')}`)
      }
    } catch (error: any) {
      console.error(error)
      alert(`❌ Maintenance failed: ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.toolContainer}>
      <h2>Day Settings Maintenance</h2>
      <p className={styles.toolDescription}>
        🔧 Manually trigger day settings maintenance job (normally runs on timer)
      </p>

      <div className={styles.buttonContainer}>
        <PrimaryButton
          buttonName={loading ? 'Running Maintenance...' : 'Trigger Maintenance'}
          onClick={onTriggerClick}
          disabled={loading}
        />
      </div>
    </div>
  )
}